import { Route } from "react-router-dom";

import HomePage from "../Pages/Home/HomePage";

import DigitalSignatureSolutions from "../Pages/Home/Products/DigitalSignature";
import HomeLayout from "../themes/Home/HomeLayout";
import AIDataExtraction from "../Pages/Home/Products/AidataExtraction";
import ChatbotSolutions from "../Pages/Home/Products/Chatbot";
import PdfWordTemplate from "../Pages/Home/Products/PdfWordTemplate";
import CspDetails from "../Pages/Home/Products/CspDetails";
import EmployeeOnboarding from "../Pages/Home/Products/EmployeeOnboarding";
import ClientOnboarding from "../Pages/Home/Products/ClientOnboarding";
import VendorOnboarding from "../Pages/Home/Products/VendorOnboarding";
import PrivacyPolicy from "../Pages/Home/Legal/PrivacyPolicy";
import TermsAndConditions from "../Pages/Home/Legal/TermsConditions";
import { CookiePolicy } from "../Pages/Home/Legal/CookiePolicy";
import AboutUs from "../Pages/Home/AboutUs";
import PricingDetails from "../Pages/Home/PricingDetails";
import ContactUs from "../Pages/Home/ContactUs";
import CancellationPolicy from "../Pages/Home/Legal/CancellationPolicy";
import ShippingPolicy from "../Pages/Home/Legal/ShippingPolicy";
import PlanUpgrade from "../Pages/Home/PlanUpgrade";
import AllPricingList from "../Pages/Home/AllPricingList";
import ServicesIndex from "../Pages/Home/Services/ServicesIndex";
import ApplicationDevelopment from "../Pages/Home/Services/ApplicationDevelopment";
import StaffingSolutions from "../Pages/Home/Services/StaffingSolutions";
import BookingDetails from "../Pages/Home/Products/BookingDetails";

const HomeRoutes = () => {
  return (
    <Route path="/" element={<HomeLayout />}>
      <Route index element={<HomePage />} />
      <Route path="/whatsapp-ordering" element={<BookingDetails />} />
      <Route
        path="/digital-signature-solution"
        element={<DigitalSignatureSolutions />}
      />
      <Route path="/ai-data-extraction" element={<AIDataExtraction />} />
      <Route path="/intelligent-chatbot" element={<ChatbotSolutions />} />
      <Route path="/pdf-word-template-filling" element={<PdfWordTemplate />} />
      <Route path="/content-security-policy" element={<CspDetails />} />
      <Route path="/employee-onboarding" element={<EmployeeOnboarding />} />
      <Route path="/client-onboarding" element={<ClientOnboarding />} />
      <Route path="/vendor-onboarding" element={<VendorOnboarding />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/contact-us" element={<ContactUs />} />
      {/* <Route path="/pricing" element={<PricingDetails />} /> */}
      <Route path="/pricing" element={<AllPricingList />} />
      <Route path="/services" element={<ServicesIndex />} />
      <Route path="/services/application-development" element={<ApplicationDevelopment />} />
      <Route path="/services/staffing-solutions" element={<StaffingSolutions />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
      <Route path="/cookie-policy" element={<CookiePolicy />} />
      <Route path="/cancellation-refund" element={<CancellationPolicy />} />
      <Route path="/shipping-policy" element={<ShippingPolicy />} />
    </Route>
  );
};

export default HomeRoutes;
